import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type DialogHeaderProps = ComponentProps<'div'>;

const DialogHeader = ({ className, ...props }: DialogHeaderProps) => {
  return (
    <div data-slot="dialog-header" className={cn('flex flex-col gap-2', className)} {...props} />
  );
};

export default DialogHeader;
